import { Button } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';

interface AddItemButtonProps {
  label: string;
  onClick: () => void;
}

const AddItemButton = ({ label, onClick }: AddItemButtonProps) => (
  <Button leftIcon={<AddIcon />} colorScheme="yellow" onClick={onClick} mt={4}>
    Add {label}
  </Button>
);

export default AddItemButton;
